import { render, staticRenderFns } from "./ArticleAdd.vue?vue&type=template&id=003d4dfd"
import script from "./ArticleAdd.vue?vue&type=script&lang=js"
export * from "./ArticleAdd.vue?vue&type=script&lang=js"
import style0 from "./ArticleAdd.vue?vue&type=style&index=0&id=003d4dfd&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports